import { useState } from "react";

const socials = [
  {
    id: 1,
    logo: "▣",
    label: "INSTAGRAM",
    handle: "@nastyauthentic",
    url: "https://www.instagram.com/nastyauthentic/",
  },
  {
    id: 2,
    logo: "◈",
    label: "LINKEDIN",
    handle: "Nasty Authentic",
    url: "https://www.linkedin.com/company/nasty-authentic/?",
  },
  {
    id: 3,
    logo: "✉",
    label: "FACEBOOK",
    handle: "Nasty Authentic",
    url: "https://www.facebook.com/profile.php?id=61588794523685",
  },
];

function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [done, setDone] = useState(false);
  const send = () => {
    if (!form.name || !form.email.includes("@")) {
      alert("Name or Email has empty fields.");
      return;
    }
    setDone(true);
    setForm({ name: "", email: "", message: "" });
    setTimeout(() => setDone(false), 3000);
  };

  return (
    <div className="page">
      <p className="section-title">REACH OUT</p>
      <h1 className="bigTitle">CONTACT US</h1>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 72 }}>
        <div>
          <h2
            style={{
              fontSize: 12,
              letterSpacing: "0.25em",
              marginBottom: 28,
              fontWeight: 700,
              color: "#888",
            }}
          >
            GET IN TOUCH
          </h2>
          {done ? (
            <p
              style={{
                padding: "36px 0",
                fontSize: 12,
                letterSpacing: "0.2em",
                fontFamily: "monospace",
              }}
            >
              ✓ MESSAGE SENT. WE'LL BE IN TOUCH.
            </p>
          ) : (
            <>
              <input
                className="contact-input"
                placeholder="NAME"
                value={form.name}
                onChange={(e) =>
                  setForm((p) => ({ ...p, name: e.target.value }))
                }
              />
              <input
                className="contact-input"
                style={{ marginTop: 14 }}
                placeholder="EMAIL"
                value={form.email}
                onChange={(e) =>
                  setForm((p) => ({ ...p, email: e.target.value }))
                }
              />
              <textarea
                style={{ marginTop: 14 }}
                className="contact-textarea"
                placeholder="MESSAGE"
                value={form.message}
                onChange={(e) =>
                  setForm((p) => ({ ...p, message: e.target.value }))
                }
              />
              <button className="contact-sendbtn" onClick={send}>
                SEND MESSAGE
              </button>
            </>
          )}
        </div>
        <div>
          <h2
            style={{
              fontSize: 12,
              letterSpacing: "0.25em",
              marginBottom: 28,
              fontWeight: 700,
              color: "#888",
            }}
          >
            FOLLOW US
          </h2>
          {socials.map((social) => (
            <a
              key={social.id}
              className="contact-socialLinks"
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span style={{ fontSize: 15, width: 20 }}>{social.logo}</span>
              <span style={{ fontSize: 10, letterSpacing: "0.25em" }}>
                {social.label}
              </span>
              <span style={{ marginLeft: "auto", fontSize: 11, color: "#333" }}>
                →
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ContactPage;
